import { Link } from "react-router-dom";
import nextDouble from "../assets/images/icons/next-double.svg";
import { useTranslation } from "../components/Localization";
import RoomHeader from "../components/RoomHeader";

export default function WarScorePage() {
  const { t } = useTranslation();
  return <main className="screen score war-score">
    <RoomHeader roomId="war" />
    <div className="score-copy">
      <strong>{t("common.completed")}</strong>
      <div>{Array.from({ length: 2 }, (_, index) => <i key={index} />)}</div>
      <span>2/2</span>
    </div>
    <Link className="war-score-button" to="/befejezes" aria-label={t("common.next")}><img src={nextDouble} alt="" /></Link>
  </main>;
}
